import { Col } from "reactstrap";
import { H2, LI, OL } from "../../../../AbstractElements";
import { OrderListTitle } from "../../../../Constants/Constants";

const OrderList = () => {
  return (
    <Col md="6" xxl="3">
      <div className="card-wrapper border rounded-3 h-100 bg-warning-light">
        <H2 className="sub-title fw-bold">{OrderListTitle}</H2>
        <OL className="simple-list">
          <LI>This is a list.</LI>  
          <LI>It appears completely unstyled.</LI>
          <LI>Structurally, it&apos;s still a list.</LI>
          <LI>However, this style only applies to immediate child elements.</LI>
          <LI>Nested lists:
            <OL>
              <LI>are unaffected by this style</LI>
              <LI>will still show a bullet</LI>
              <LI>and have appropriate left margin</LI>
            </OL>
          </LI>
          <LI>This may still come in handy in some situations.</LI>
        </OL>
      </div>
    </Col>
  );
};
export default OrderList;
